import { render, staticRenderFns } from "./ListTipoFoto.vue?vue&type=template&id=1c8544c4"
import script from "./ListTipoFoto.vue?vue&type=script&lang=js"
export * from "./ListTipoFoto.vue?vue&type=script&lang=js"
import style0 from "./ListTipoFoto.vue?vue&type=style&index=0&id=1c8544c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports